// extracted by mini-css-extract-plugin
module.exports = {"notification-wrapper":"styles_notification-wrapper__1JyAs","notification":"styles_notification__3t1Fn"};